import { Deserializable } from './deserializable';
import { GroupPermissions } from './groupPermissions';


export class GroupPermissionsList implements Deserializable {
  permissions: GroupPermissions[] = [];

  deserialize(input: any) {

    Object.assign(this, input);
    if (!input) {
      return this;
    }

    return this;
  }
}
